const ENV:string = 'DEV'; // DEV/PROD

// Configuration for DEV environment
const DEV_CONFIG = {
   API_BASE_URL: 'https://dev-api.transfercenter.one/',
   PHP_BASE_URL: 'https://transfercenter.one',
   SOCKET_URL: 'https://dev-socket.transfer-center.com',
   PAYPAL_CLIENT_ID: 'AZTVoi3uFKbgLIgBvE26rmoqq5iqRRfdFJ0e9tQlxG4PcxC28VYOYJVc2T0seROhikiNf2s6ufDLM3Cu', //sandbox (16-01-2025)
   STATIC_ALB_ARN : 'arn:aws:elasticloadbalancing:ap-northeast-1:584925688451:loadbalancer/app/transfercenter0-com-LB/4f98cfd8f3a57810',//Transfercenter0 ALB
   downloadDomain: 'net0.download',
   downloadDomain2: 'transfercenter0.com',
   terms_version: 'Ver.2.0 (2026-09-01)',
   sla_version:'Ver.1.1 (2026-09-01)',
 };

// Configuration for PROD environment
const LIVE_CONFIG = {
    API_BASE_URL: 'https://api-live.transfercenter.jp/',
    // API_BASE_URL: 'https://api-live-dot-mtc-filetransfer.an.r.appspot.com/',
    PHP_BASE_URL: 'https://app.transfercenter.jp',
    SOCKET_URL: 'https://socket.transfer-center.com',
    PAYPAL_CLIENT_ID: 'Ac-JIfWrd9RD-zMCyvP9l-URmouY74BmPmptm55P0BB0uG8Dcmd94YKOGzHRULUyufiAqEa5-p9u73sE', //live
    STATIC_ALB_ARN : 'arn:aws:elasticloadbalancing:ap-northeast-1:584925688451:loadbalancer/app/filetransfercenter-com-ALB/e832e7defa584a0f',//filetransfercenter ALB
    downloadDomain: 'net.download',
    downloadDomain2: 'filetransfercenter.com',
    terms_version: 'Ver.2.0 (2026-09-01)',
    sla_version:'Ver.1.1 (2026-09-01)',
};

// Bump this value (any different string) whenever you want the "New update available"
// modal to be shown again to every visitor — logged in or logged out. It's consumed by
// AppUpdateNoticeService, which is wired into the login page and the sidebar; nothing
// else needs to change. Previously-seen users are tracked per-value in localStorage, so
// changing this string is what makes the modal reappear for everyone.
export const APP_UPDATE_VERSION = 'v5';

//Other constants can be defined here as needed
const OTHER_CONFIG: any = {  
    SITE_URL:"https://www.transfercenter.jp", 
    CURRENCY_SYMBOL: 'JPY',
    myCOUNTRY: 'JP',
    currencySign: '¥',
    myEMAIL_REGEXP: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$',
    myPASSWORD_REGEXP:"(?=.*[0-9]).{8,}$", //ADDED BY SUBHENDU
    ENV: ENV
}

// Export the appropriate configuration based on the ENV variable
export const AppConfig = {
  ...(ENV === 'PROD' ? LIVE_CONFIG : DEV_CONFIG),
  ...OTHER_CONFIG
};

// Export PHP_BASE_URL separately for easy access in templates and components
export const PHP_BASE_URL = AppConfig.PHP_BASE_URL;

// Export DOWNLOAD_DOMAIN from the centralized config
export const DOWNLOAD_DOMAIN = AppConfig.downloadDomain;

// Export DOWNLOAD_DOMAIN2 from the centralized config
export const DOWNLOAD_DOMAIN2 = AppConfig.downloadDomain2;

// Export PAYPAL_CLIENT_ID from the centralized config
export const PAYPAL_CLIENT_ID = AppConfig.PAYPAL_CLIENT_ID;



// Export StringConstant (legacy support - maps to AppConfig)
export const StringConstant = AppConfig;

// Export CONVERTER utility functions
export const CONVERTER = {
    storage(value: any){
        var retunValue = value/1024;
        var finalValue = '';

        if(retunValue >= 1024){
            finalValue = retunValue/1024+' TB';
        }
        else
        {
            finalValue = retunValue+' GB';
        }
        return finalValue;
    },
    storageSmall(bytes:any){
        if(bytes >= 1073741824)       { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
        else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
        else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
        else if (bytes > 1)           { bytes = bytes + " bytes"; }
        else if (bytes == 1)          { bytes = bytes + " byte"; }
        else                          { bytes = "0 bytes"; }
        return bytes;
    }
};